module.exports = __webpack_public_path__ + "static/media/level_09-10.26f0fabf.jpg";